/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Complete_Case_Data_TitleInputs */

const en_case_complete_case_data_title = /** @type {(inputs: Case_Complete_Case_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Case Data`)
};

const pt_br2_case_complete_case_data_title = /** @type {(inputs: Case_Complete_Case_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar dados do caso`)
};

/**
* | output |
* | --- |
* | "Complete Case Data" |
*
* @param {Case_Complete_Case_Data_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_complete_case_data_title = /** @type {((inputs?: Case_Complete_Case_Data_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Complete_Case_Data_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_complete_case_data_title(inputs)
	return pt_br2_case_complete_case_data_title(inputs)
});